import React from 'react';

import { FormikErrors, FormikTouched } from 'formik';

import Input from 'components/Input/Input';

interface PermanentFormValues {
    playerAvailability?: number;
    setAsFree?: boolean;
}

interface PermanentProps {
    values: PermanentFormValues;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
    touched?: FormikTouched<PermanentFormValues>;
    errors?: FormikErrors<PermanentFormValues>;
}

const Permanent: React.FC<PermanentProps> = ({
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
}) => {
    return (
        <div className="flex flex-col gap-9 w-full">
            <div className="space-y-2">
                <Input
                    label="Availability"
                    id="availability"
                    name="playerAvailability"
                    type="number"
                    className="w-[140px]"
                    placeholder="Set availability"
                    min={0}
                    value={values.playerAvailability || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isRequired={values.setAsFree}
                    state={
                        touched?.playerAvailability && Boolean(errors?.playerAvailability)
                            ? 'error'
                            : 'default'
                    }
                    description={
                        touched?.playerAvailability
                            ? errors?.playerAvailability?.toString()
                            : ''
                    }
                />
            </div>
            <p className="text-sm text-zinc-500">Permanent events won't have an end date</p>
        </div>
    );
};

export default Permanent;

